<template>
    <div>
        <v-card class="mb-5">
            <v-card-text>
                <v-form @submit.prevent="formUpdate" ref="refupdate" lazy-validation>
                    <v-row>
                        <!-- name -->
                        <v-col cols="12" md="6" class="px-2">
                            <v-text-field
                                :label="$t('Nombre completo')"
                                type="text"
                                name="name"
                                outlined
                                dense
                                v-model="data.name"
                                :rules="[rules.required]"
                                :error="errors['name'] ? true :false"
                                :error-messages="errors['name'] ? errors['name'][0] : ''"
                            ></v-text-field>
                        </v-col>
                        <!-- end name -->
                        <!-- email -->
                        <v-col cols="12" md="6" class="px-2">
                            <v-text-field
                                :label="$t('Correo electrónico')"
                                type="email"
                                name="email"
                                outlined
                                dense
                                v-model="data.email"
                                :rules="[rules.required, rules.email]"
                                :error="errors['email'] ? true :false"
                                :error-messages="errors['email'] ? errors['email'][0] : ''"
                            ></v-text-field>
                        </v-col>
                        <!-- end email -->
                        <!-- phone -->
                        <v-col cols="12" md="6" class="px-2">
                            <vue-tel-input-vuetify
                                :label="$t('Tel/cel *')"
                                outlined
                                dense
                                :onlyCountries="['bo', 'us', 'es', 'ar', 'cl', 'co', 'ec', 'mx', 'pe', 've', 'br']"
                                :default-country="defaultCountry"
                                :value="data.tmpPhone"
                                @input="onInput"
                                :error="errors['phone'] ? true :false"
                                :error-messages="errors['phone'] ? errors['phone'][0] : ''"
                            ></vue-tel-input-vuetify>
                        </v-col>
                        <!-- end phone -->
                        <!-- country -->
                        <v-col cols="12" md="6" class="px-2">
                            <v-select
                                :items="itemsCountry"
                                item-value="val"
                                item-text="text"
                                :label="$t('Moneda *')"
                                outlined
                                dense
                                v-model="data.country"
                                :rules="[rules.required]"
                                :error="errors['country'] ? true :false"
                                :error-messages="errors['country'] ? errors['country'][0] : ''"
                            ></v-select>
                        </v-col>
                        <!-- end country -->
                        <!-- address -->
                        <v-col cols="12" md="6" class="px-2">
                            <v-text-field
                                :label="$t('Dirección')"
                                type="text"
                                name="address"
                                outlined
                                dense
                                v-model="data.address"
                                :rules="[rules.required]"
                                :error="errors['address'] ? true :false"
                                :error-messages="errors['address'] ? errors['address'][0] : ''"
                            ></v-text-field>
                        </v-col>
                        <!-- end address -->
                        <!-- language -->
                        <v-col cols="12" md="6" class="px-2">
                            <v-select
                                :items="itemsLanguages"
                                item-value="val"
                                item-text="text"
                                :label="$t('Idioma principal')+' *'"
                                outlined
                                dense
                                v-model="data.locale"
                                :rules="[rules.required]"
                                :error="errors['locale'] ? true :false"
                                :error-messages="errors['locale'] ? errors['locale'][0] : ''"
                            ></v-select>
                        </v-col>
                        <!-- end language -->
                        <v-col cols="12">
                            <h4>{{$t('Cambiar contraseña')}}</h4>
                            <v-divider class="mb-4"></v-divider>
                        </v-col>
                        <!-- update password -->
                        <v-col cols="12" md="6">
                            <v-text-field
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                :label="$t('Contraseña actual *')"
                                :hint="$t('Mínimo 8 caracteres')"
                                counter
                                dense
                                outlined
                                @click:append="show1 = !show1"
                                v-model="data.password"
                                :error="(errors['password']) ? true : false"
                                :error-messages="(errors['password']) ? errors['password'][0] : ''"
                            ></v-text-field>
                        </v-col>
                        <!-- password -->
                        <v-col cols="12" md="6">
                            <v-flex xs12>
                                <div class="input-container d-flex">
                                    <v-text-field
                                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show2 ? 'text' : 'password'"
                                        :label="$t('Contraseña nueva *')"
                                        :hint="$t('Mínimo 8 caracteres')"
                                        counter
                                        dense
                                        outlined
                                        @click:append="show2 = !show2"
                                        v-model="data.newPassword"
                                        :error="(errors['newpassword']) ? true : false"
                                        :error-messages="(errors['newpassword']) ? errors['newpassword'][0] : ''"
                                    ></v-text-field>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                class="ml-2"
                                                fab
                                                dark
                                                small
                                                color="primary"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="data.newPassword = genRandom()"
                                            >
                                                <v-icon dark>
                                                    mdi-reload
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{$t('Generar')}}</span>
                                    </v-tooltip>
                                </div>
                            </v-flex>
                        </v-col>
                        <!-- end password -->
                        <v-col cols="12" sm="12" class="text-center">
                            <v-btn type="submit" dark color="primary">
                                {{$t('Actualizar')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

       <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->
    </div>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            show1: false,
            show2: true,
            data: {
                id: '',
                name: '',
                email: '',
                tmpPhone: '',
                phoneCode: '',
                phoneIso: '',
                phoneValid: false,
                phone: '',
                address: '',
                password: '',
                newPassword: '',
                country: '',
                locale: ''
            },
            itemsCountry: [
                {val: 'bo', text: 'Bolivia (Bs.)'},
                {val: 'us', text: 'Estados Unidos (US$)'},
                {val: 'es', text: 'Europa (EUR)'},
                {val: 'ar', text: 'Argentina (ARS)'},
                {val: 'cl', text: 'Chile (CLP)'},
                {val: 'co', text: 'Colombia (COP)'},
                {val: 'ec', text: 'Ecuador (US$)'},
                {val: 'mx', text: 'México (MXN)'},
                {val: 'pe', text: 'Perú (PEN)'},
                {val: 've', text: 'Venezuela (US$)'},
                {val: 'br', text: 'Brasil (R$)'}
            ],
            itemsLanguages: [
                {val: 'es', text: 'Español'},
                {val: 'en', text: 'Inglés'},
                {val: 'pt', text: 'Português'},
            ],
            defaultCountry: 'bo',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {},
        }
    },
    props: ['dataUser', 'dataCountry', 'slug', 'locale'],
    created() {
        var tmpUser = JSON.parse(this.dataUser)
        
        this.data.id = tmpUser.id
        this.data.name = tmpUser.name
        this.data.email = tmpUser.email
        // this.data.phone = tmpUser.phone
        this.data.tmpPhone = tmpUser.code + tmpUser.phone
        this.data.address = tmpUser.address
        this.data.country = this.dataCountry
        this.data.locale = this.locale
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.data.phoneCode = '+'+country.dialCode
            this.data.phone = number.significant
            this.data.tmpPhone = number.international
            this.data.phoneIso = country.iso2
            this.data.phoneValid = valid

            // this.data.country = country.iso2.toLowerCase()
        },
        /**
         * Update
         */
        genRandom () {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 10; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result
            // this.data.password = result
        },
        async formUpdate () {
            if (this.$refs.refupdate.validate()) {
                this.overlay = true
                this.errors = {}
                const formData = new FormData()
                formData.append('name', this.data.name)
                formData.append('email', this.data.email)
                formData.append('phone', this.data.phone)
                formData.append('address', this.data.address)
                formData.append('password', this.data.password)
                formData.append('newpassword', this.data.newPassword)
                formData.append('phone', this.data.phone)
                formData.append('code', this.data.phoneCode)
                formData.append('iso2', this.data.phoneIso)
                formData.append('country', this.data.country)
                formData.append('slug', this.slug)
                formData.append('locale', this.data.locale)
                formData.append('_method', 'PUT')

                await axios.post(`/admin/account/${this.data.id}`, formData)
                .then(response => {
                    // console.log(response);
                    if (response.data.msg == 'ok') {
                        this.$alert(this.$t('Se recargara la página en 3 segundos.'), this.$t('Datos actualizados con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')});
                        setTimeout(() => {
                            // reload page
                            location.reload()
                        }, 300);
                    }
                    if (response.data.pwd !== '') {
                        if (response.data.pwd == 'success') {
                            this.data.password = ''
                            this.data.newPassword = ''
                            this.$alert('', this.$t('Contraseña actualizada con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')});
                        } else {
                            this.$alert('', this.$t('Contraseña actual incorrecta.'), 'error', {confirmButtonText: this.$t('Continuar')});
                        }
                    }
                    this.overlay = false
                })
                .catch(error => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.errors = error.response.data.errors
                    this.overlay = false
                })
            }
        }
    },
}
</script>
